var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v(" Please obtain the API-Key for the package to use it. See "),_c('router-link',{attrs:{"to":{name: 'MemberPackagePage'}}},[_vm._v("Package Page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }